var API_DOMAIN = "https://zencrackersdemo.zentexus.com/api";
// var API_DOMAIN = "http://localhost/zencrackers_demo_api/api";
export default API_DOMAIN;